<div class="invoice-content py-2">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="grid-container search-holder">
        <ul class="list-inline mb-3 mb-sm-5">
          <!-- <li class="list-inline-item my-2 my-lg-0">
                 <button
                 mat-flat-button
                 [ngClass]="{ 'active-selection': isUserLogsActive }"
                 (click)="onSelectUserLogs()"
                 >
                 Users
                 </button>
             </li>
             <li class="list-inline-item my-2 my-lg-0">
                 <button
                 mat-flat-button
                 [ngClass]="{ 'active-selection': isSystemLogsActive }"
                 (click)="onSelectSystemLogs()"
                 >
                 System
                 </button>
             </li> -->
          <li class="list-inline-item my-2 my-lg-0">
            <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <div class="calendar-btn">
              <input
                matInput
                [matDatepicker]="dpFrom"
                disabled
                [min]="minFromDate"
                placeholder="MM/DD/YYYY"
                [max]="maxDate"
                (dateChange)="changeFromDate($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dpFrom"
              ></mat-datepicker-toggle>
              <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
            </div>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
          </li>
          <li class="list-inline-item my-2 my-lg-0">
            <div class="calendar-btn">
              <input
                matInput
                [matDatepicker]="dpTo"
                disabled
                [min]="minToDate"
                placeholder="MM/DD/YYYY"
                [max]="maxDate"
                (dateChange)="changeToDate($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dpTo"
              ></mat-datepicker-toggle>
              <mat-datepicker #dpTo disabled="false"></mat-datepicker>
            </div>
          </li>
          <li class="list-inline-item my-2 my-lg-0 ">
            <div class="search-holder">
              <input
                type="text"
                placeholder="{{ 'pages.newRetailer.search' | translate }}"
                matInput
                class="
                  rounded-pill
                  px-3
                  py-2
                  mb-0
                  border-0
                  bg-light
                  w-100
                  me-0
                  input-search
                  ms-3
                "
                (keyup)="quickSearch()"
                [(ngModel)]="searchValue"
              />
            </div>
          </li>
          <li class="list-inline-item my-2 my-lg-0 float-end">
            <button
              mat-stroked-button
              color="primary"
              class=""
              (click)="exportData()"
            >
              <span translate class="translate"
                >pages.newRetailer.download</span
              >
              <i class="mi mi-save-alt"></i>
            </button>
          </li>
        </ul>

        <ag-grid-angular
          style="width: 100%; height: 60vh"
          class="ag-theme-material"
          [rowHeight]="40"
          [enableFilter]="true"
          [enableSorting]="true"
          [enableColResize]="true"
          [rowSelection]="'single'"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          (gridReady)="onGridReady($event)"
          (selectionChanged)="onSelectionChanged($event)"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
